import { render, staticRenderFns } from "./CruiseData.vue?vue&type=template&id=053fe9ca&"
import script from "./CruiseData.vue?vue&type=script&lang=js&"
export * from "./CruiseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports